<template>
  <el-table-column
    prop="private_email"
    label="Privát email"
    sortable="custom"
    min-width="200"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.private_email || '-' }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'private_email',
  };
</script>
